import {
  GET_REUSEABLE_LIST_SUCCESS,
  GET_REUSEABLE_LIST_FAIL,
  GET_REUSEABLE_DETAILS_SUCCESS,
  GET_REUSEABLE_DETAILS_FAIL,
  ADD_REUSEABLE_SETTING_SUCCESS,
  ADD_REUSEABLE_SETTING_FAIL,
  UPDATE_REUSEABLE_SUCCESS,
  UPDATE_REUSEABLE_FAIL,
  DELETE_REUSEABLE_SUCCESS,
  DELETE_REUSEABLE_FAIL,
  EXPORT_REUSEABLE_EXCEL_SUCCESS,
  EXPORT_REUSEABLE_EXCEL_FAIL,
  RESET_REUSEABLE_SETTING_STATE,
  RESET_REUSEABLE_SETTING_ACTION_STATE,
} from "./actionTypes"

const INIT_STATE = {
  reuseableList: [],
  reuseableSettingDetails: [],
  addReuseableSetting: [],
  editReuseableSetting: [],
  delReuseableSetting: [],
  updatePw: [],
  exportExcel: [],
  error: [],
}

const ReuseableReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_REUSEABLE_LIST_SUCCESS:
      if (action?.payload?.api === 'rental_cc') {
        return { ...state, rentalCCList: action.payload?.data };
      } else if (action?.payload?.api === 'service_cc') {
        return { ...state, serviceCCList: action.payload?.data };
      } else {
        return {
          ...state,
          reuseableList: action.payload?.data,
        }
      }
    case GET_REUSEABLE_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_REUSEABLE_DETAILS_SUCCESS:
      return {
        ...state,
        reuseableSettingDetails: action.payload,
      }

    case GET_REUSEABLE_DETAILS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case ADD_REUSEABLE_SETTING_SUCCESS:
      return {
        ...state,
        addReuseableSetting: action.payload,
        reuseableSettingDetails: action.payload.data,
      }

    case ADD_REUSEABLE_SETTING_FAIL:

      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_REUSEABLE_SUCCESS:
      return {
        ...state,
        editReuseableSetting: action.payload,
        reuseableSettingDetails: action.payload.data,
      }

    case UPDATE_REUSEABLE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case DELETE_REUSEABLE_SUCCESS:
      return {
        ...state,
        delReuseableSetting: action.payload
      }

    case DELETE_REUSEABLE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case EXPORT_REUSEABLE_EXCEL_SUCCESS:
      return {
        ...state,
        exportExcel: action.payload
      }

    case EXPORT_REUSEABLE_EXCEL_FAIL:
      return {
        ...state,
        exportExcel: action.payload,
      }
    case RESET_REUSEABLE_SETTING_STATE:
      return {
        ...state,
        addReuseableSetting: [],
        editReuseableSetting: [],
        delReuseableSetting: [],
        updatePw: [],
        error: [],
        exportExcel: [],
        reuseableList: [],
      }
    case RESET_REUSEABLE_SETTING_ACTION_STATE:
      return {
        ...state,
        serviceCCList: [],
        rentalCCList: [],
        addReuseableSetting: [],
        editReuseableSetting: [],
        delReuseableSetting: [],
        updatePw: [],
        exportExcel: [],
        reuseableList: [],
        error: []
      }
    default:
      return state
  }
}

export default ReuseableReducer
